import { Carousel } from "react-responsive-carousel"
import ImvCarousel from "./Home/_imvImagesCarousel"
import { Transition } from "@headlessui/react"
import { HouseBuildingIcon, BathroomIcon, BedroomIcon, AreaIcon, CurrencyIcon, PetsIcon } from "./assets/ImvIcons"
import { ChatIcon } from "./assets/icons"
import { MoedaFormatada } from "./assets/_ImvCardAssets"
import ClientContact from "./[modal]ClientContact"
import { useState } from "react"
import { CloseIcon } from "./assets/CommonIcons"

export const ImvCardModal = ({ imv, onClose, isOpen }) => {
    const [contactModal, setContactOpen] = useState(false)

    return (
        <section className="fixed z-10 top-0 w-full p-1 flex flex-col place-content-center h-screen bg-[#00000065]">

            {/* Modal de Contato */}
            {contactModal && (
                <ClientContact setContactOpen={setContactOpen} imv={imv} />
            )}

            {/* Modal Do Card */}
            <article className="w-11/12 max-xl:w-full aspect-video max-[1280px]:h-full flex items-center max-[1280px]:items-evenly xl:h-3/4 z-20 overflow-hidden max-sm:w-full mx-auto rounded-xl">
                {/* content wraper */}
                <section id="modal_" className="xl:flex xl:flex-row max-[1280px]:grid xl:[1280px]:h-[40rem] max-[1320px]:">

                    {/* Carrousel de Imagens do Imóvel */}
                    <header className="
                        xl:w-3/4
                        flex
                        items-center
                        max-[1280px]:w-full
                        max-[1279px]:h-[25rem] xl:min-h-full max-[1279px]:rounded-t-xl     overflow-hidden"
                    >
                        <ImvCarousel nreg={imv.nreg} modal={true} />
                    </header>

                    <div className="py-5 max-sm:pb-5
                        h-full
                        w-full xl:grid
                        max-sm:grid
                        xl:w-1/4 max-[1279px]:w-full max-[1279px]:h-[auto] xl:rounded-r-xl max-[1280px]:rounded-b-xl
                        bg-gradient-to-br from-10% from-[#1d4aa7] to-[#193f8d]"
                    >

                        <main className="p-5 grid h-full
                            xl:gap-y-5
                            max-sm:flex max-sm:flex-col max-sm:gap-y-10 
                            max-xl:gap-y-5
                            max-xl:grid max-xl:justify-stretch"
                        >

                            <section className="xl:mb-5 max-xl:w-full">
                                <h2 className="text-3xl"> {imv.end} </h2>
                                <h3 className="text-xl font-thin"> {imv.bairro} </h3>
                            </section>

                            {/* Exibido a esquerda em min-xl */}
                            <section className="max-sm:aspect-video max-xl:flex justify-stretch max-xl:gap-x-10 max-xl:h-auto gap-y-2 h-96 shadow-[inset_0_0_1.5rem_#0007] rounded-xl p-5 overflow-y-scroll">
                                <div className="max-sm:font-[4pt]">
                                    <ModalSpec icon={<HouseBuildingIcon />} field={imv.tipo} />
                                    <ModalSpec icon={<BedroomIcon />} field={imv.quartos + `${imv.quartos > 1 ? ' Quartos' : ' Quarto'}`} />
                                    <ModalSpec icon={<AreaIcon />} field={imv.area + `M²`} />

                                    <ModalSpec icon={<CurrencyIcon />} field={<MoedaFormatada valor={imv.preco} />} />

                                    <ModalSpec icon={<PetsIcon />} field={'Aceita Pets'} />
                                </div>
                                <div className="">
                                    <h2 className="text-center text-xl underline decoration-1 underline-offset-2 my-5"> Descrição do imóvel: </h2>
                                    <p> {imv.descricao} </p>

                                </div>

                            </section>
                            <footer className="gap-y-2 pb- h-20 items-center">
                                <h1 className="text-[8pt] font-thin"> Código: {imv.nreg} </h1>

                                <div className="flex gap-x-3">
                                    <button className="flex w-full justify-center gap-x-2 items-center h-16 p-3 bg-green-600 rounded-md active:bg-green-400"
                                        onClick={() => setContactOpen(true)} >
                                        <span className="aspect-square h-8"> <ChatIcon /> </span>
                                        <p className="max-[1480px]:font-[1pt]">
                                            Saber Mais
                                        </p>
                                    </button>
                                    <button className="aspect-square items-center h-16 p-3 bg-red-700 self-center content-center rounded-md active:bg-red-400"
                                        onClick={() => onClose()}>
                                        {/* <p className="w-full text-2xl max-[1480px]:text-sm">
                                            Fechar
                                        </p> */}
                                        <span className="aspect-square  w-full"> <CloseIcon /> </span>
                                    </button>

                                </div>

                            </footer>
                        </main>

                    </div>

                </section>
            </article>
        </section>
    )
}

const ModalSpec = ({ icon, field }) => {
    return (
        <article className="flex items-center mb-1 h-10 gap-x-5">
            <span className="fill-white aspect-square h-full">
                {icon}
            </span>
            <h4 className="capitalize"> {field} </h4>
        </article>
    )
}


// <article className="w-11/12 h-5/6 z-20 overflow-hidden max-sm:w-full mx-auto rounded-lg">
//     {/* content wraper */}
//     <section id="modal_" className="flex h-full max-[1320px]:grid">
//         <header className="flex items-center w-3/4 max-[1320px]:w-full min-h-full rounded-lg">
//             <ImvCarousel nreg={imv.nreg} modal={true} />
//         </header>

//         <div className="p-10 w-1/4 max-[1320px]:w-full bg-[#1d4aa7]">
//             <h1> Registro: {imv.nreg} </h1>
//             <button onClick={() => onClose()}> Fechar </button>
//         </div>

//     </section>
// </article>
